
import { MeRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Recaptcha from 'services/recaptcha';

let _scope;
let _userRestService;
let _auth;

const _serviceDependencies = ['$scope', '$focus', '$state', '$window', '$location', 'Auth',
    'Util', 'UserRestService', 'Sso'];

/**
 * @ngdoc service
 * @name controllers.Confirm
 *
 * @description
 * Account Confirmation controller
 */
class Confirm {

    /**
     * @param  {any} $scope
     * @param  {any} $focus
     * @param  {any} $state
     * @param  {any} $window
     * @param  {any} Auth
     * @param  {any} Util
     * @param  {any} UserRestService
     * @param  {any} Sso
     */
    constructor(
        $scope, $focus, $state, $window, $location, Auth, Util,
        UserRestService, Sso,
    ) {


        // if the user doesn't have token, go to login
        if (!Util.getToken()) {

            Auth.gotoLogin();

        } else {

            Mixpanel.send('ConnectWeb Account Confirmation Open', {
                Source: 'Direct',
            });

        }

        this.Util = Util;
        this.$window = $window;
        this.$state = $state;
        this.Auth = Auth;
        this.$focus = $focus;
        this.MeRepository = MeRepository;
        this.Sso = Sso;

        _scope = $scope;

        _userRestService = UserRestService;
        _auth = Auth;
        _auth.loading = false;
        _auth.error = false;

        _scope.submitted = false;
        _scope.isDisabled = true;
        _scope.emailRegExp = this.Util.getEmailValidationRegExp();
        _scope.email = MeRepository.getMyEmail();

        _scope.Recaptcha = Recaptcha;

        this.resendEmailRetries = 0;

        if (this.Sso.isThirdPartyLogin) {

            // hide change language button if we receive change_lang=false param in the url
            _scope.showChangeLang = this.Sso.getChangeLang();

            _scope.clientId = this.Sso.getClientId();

        }

        // meRepository obeservable
        // const meObservable = MeRepository.getObservable();
        // const onNextMe = (data) => {

        //     // redirect to dashboard if the user gdpr is confirmed
        //     if (data && data.data.attributes.gdpr_confirm) {

        //          $location.path('/dashboard/devices');

        //     }

        // };
        // const meSubscriber = meObservable.subscribe(onNextMe, () => { }, () => { });

        Auth.sendAcpPing();

        // _scope.$on('$destroy', () => {

        //     meSubscriber.dispose();

        // });

    }

    changeEmail() {

        _scope.isDisabled = false;
        this.$focus(_scope, 'email');

    }

    resendEmail() {

        const captchaRespose = _scope.Recaptcha.getCaptchaResponse();
        const headers = {};

        if (captchaRespose) {

            headers['X-Avira-Captcha-Token'] = captchaRespose;

        }

        // Check if the email is valid
        const formIsValid = _scope.confirmAccountForm.$valid;

        Mixpanel.send('ConnectWeb Resend Confirmation Email Click', {
            Page: 'Auth Confirm',
        });

        _scope.submitted = true;

        if (formIsValid) {

            _auth.loading = true;

            let updateEmailPayload = {};
            const userId = this.MeRepository.getMyId();

            updateEmailPayload = {
                data: {
                    attributes: {
                        email: _scope.email,
                        language: CWCONFIG.language,
                    },
                    type: 'users',
                    id: userId,
                },
                meta: {
                    send_verify_email: true,
                    captcha: captchaRespose,
                },
            };

            _userRestService
                .update(userId, updateEmailPayload, headers)
                .then(() => {

                    _auth.loading = false;
                    _scope.isDisabled = true;
                    _auth.error = false;
                    this.resendEmailRetries = 0;
                    _scope.Recaptcha.disableCaptcha();
                    _scope.Recaptcha.setCaptchaResponse();
                    Alert.success('cw.auth.confirm.change_email_success');

                }).then(null, (err) => {

                    _auth.loading = false;
                    _auth.error = true;

                    const errors = this.Util.deepFind(err, 'data.errors');

                    if (errors && errors.length) {

                        const errorCode = errors[0].code;
                        if (errorCode === '918') {

                            _scope.Recaptcha.execute();

                        }

                    }

                });

        } else {

            this.Util.triggerAnimation('.auth-form', 'animated shake');

        }

    }

    onSubmit() {

        if (CWCONFIG.captchaConfig.accountConfirmationCaptchaRetries <= this.resendEmailRetries) {

            _scope.Recaptcha.enableCaptcha();

        }

        if (_scope.Recaptcha.isCaptchaRequired()) {

            _scope.Recaptcha.execute();

        } else {

            this.resendEmail();

        }

    }

    setCaptchaResponse(response) {

        _scope.Recaptcha.setCaptchaResponse(response);
        this.resendEmail();

    }

}

_serviceDependencies.push(Confirm);

angular.module('controllers')
    .controller('Confirm', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/auth/confirm/confirm.js